<template>
    <div class="modal modal-time-limit">
        <div class="wrapper">
            <div class="modal-time-limit__time-select" v-if="isTimeExtend">
                <div class="title">
                    <IconSpeaker class="speaker" @click="speechSynthesis(text)"></IconSpeaker>
                    <p class="modal-time-limit__title">{{ text }}</p>
                </div>

                <Slider class="sleephours__range" v-model="time" v-bind="sliderSettings"/>

                <div class="buttons">
                    <button class="btn-cancel" @click="backToCategory">
                        <span>Anuluj</span>
                    </button>
                    <button class="btn-success" @click="saveTimeExtend">
                        <span>Akceptuj</span>
                    </button>
                </div>
            </div>

            <div class="modal-time-limit__time-info" v-else>
                <div class="title">
                    <IconSpeaker class="speaker" @click="speechSynthesis(textToShow)"></IconSpeaker>
                    <p class="modal-time-limit__title">{{ textToShow }}</p>
                </div>
                
                <div class="buttons">
                    <button class="btn-cancel" @click="backToCategory">
                      <span>Anuluj</span>
                    </button>
                    <button class="btn-success" @click="timeExtend">
                      <span>Przedłuż czas</span>
                    </button>
                </div>
            </div>

            <IconClose class="close" @click="backToCategory"></IconClose>

            <i class="letter-animal" :class="{'letter-animal--select': isTimeExtend}"></i>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import IconClose from "../elements/icons/IconClose.vue";
import IconSpeaker from "../elements/icons/IconSpeaker.vue";
import { useToast } from "vue-toastification";
import Slider from '@vueform/slider';

const toast = useToast()

export default {
    name: "ModalTimeLimit",
    components: {
        IconClose,
        IconSpeaker,
        Slider
    },
    props: {
        isTimeIsUp: {
            type: Boolean
        },
        isOutOfHours: {
            type: Boolean
        },
        isTimeIsUpRemind: {
            type: Boolean
        },
        activeSubProfile: {
            type: Object
        }         
    },
    data() {
        return {
            // showModalTime: false,
            // showModalInfo: true,
            // ADD_EXTRA_TIME: '/api/krainaabc/subprofile/activity/add-extra-time?device=www',
            SET_PLAY_TIME: '/api/krainaabc/subprofile/activity/set-play-time?device=www',
            isTimeExtend: false,
            // timeExtendValue: -9,
            text: 'Przedłuż dzisiejszy limit zabawy w aplikacji',
            text2: 'Za chwilę czas zabawy z aplikacją skończy się. Poproś rodzica o pomoc.',
            text3: 'To nie jest Twój czas aktywności w aplikacji. Poproś rodzica o odblokowanie.',
            time: [0, 0],
            sliderSettings: {
                merge: 2,
                min: 0,
                max: 24,
                step: -1,
                format: function (value) {
                    let min = Math.floor((value - Math.floor(value))*60 / 30) * 30;
                    min = min.toString().length < 2 ? '00' : min;
                    return `${Math.floor(value)}:${min}`;
                }
            }            
        }
    },
    computed: {
        getPinLock() {
            return this.$store.getters.getPinLock;
        },
        textToShow() {
            if(this.isTimeIsUpRemind && !this.isOutOfHours && !this.isTimeIsUp) {
                return this.text2;
            } else {
                return this.text3;
            }
        },
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        }
    },
    watch: {
        getPinLock: {
            handler: function(value) {
                if(value && !value.isOpen && value.mode === 'timeExtend') {
                    this.isTimeExtend = true;
                }               
            },
            deep: true,
            immediate: true
        }        
    },
    methods: {
        toggleModal() {
            this.showModalTime = !this.showModalTime;
        },
        timeExtend() {
            this.$store.dispatch("changePinLock", { isOpen: true, mode: 'timeExtend' });
        },
        backToCategory() {
            if(this.isTimeIsUp || this.isOutOfHours) {
                this.$store.dispatch("changeModalBackdrop", false); 
                this.$router.push({
                    name: "Categories",
                    path: "/",
                }); 
            } else {
                this.$emit("closeModalHandle");
                this.$store.dispatch("changeModalBackdrop", false); 
                if(window.__PLAYER && window.__PLAYER.getTime() !== 0) {
                    window.__PLAYER.play();
                }
            }
                    
        },
        getHour(time) {
            let min = (time - Math.floor(time)).toFixed(2);
            let hour = time - min;

            if(hour === 24) {
                return '23:59';
            }
            else if(min < 0.5) {
                if(hour.toString().length < 2) {
                    return `0${Math.floor(hour)}:00`;
                }
                return `${Math.floor(hour)}:00`;
            } else {
                if(hour.toString().length < 2) {
                    return `0${Math.floor(hour)}:30`;
                }                
                return `${Math.floor(hour)}:30`;
            }
        }, 
        minutesToNumber(val) { 
            // konwersja stringa z godziną na liczbę zmiennoprzecinkową
            let hour = parseInt(val.split(":")[0]);
            let min = parseInt(val.split(":")[1]);
            if(min == 59) {
                min = 0;
                hour = 24;
            }
            return (hour + parseInt(min)/60).toFixed(2);
        }, 
        saveTimeExtend() {
            if(this.time && this.checkIsHourGreaterThanNow(this.getHour(this.time[1])) && this.checkIsHourSmallerThanNow(this.getHour(this.time[0]))) {
                let data = {};
                data['subProfile_id'] = this.activeSubProfile._id;
                data['play_from'] = this.getHour(this.time[0]);
                data['play_to'] = this.getHour(this.time[1]);

                axios
                    .post(this.SET_PLAY_TIME, data)
                    .then(() => {
                        toast.success("Czas został przedłużony.");
                        this.$emit("stopRecordTime");

                        this.$store.dispatch("setIsTimeIsUp", false);
                        this.$store.dispatch("setIsOutOfHours", false);

                        this.$store.dispatch("activeSubProfile");

                        this.$emit("closeModalHandle");
                    })
                    .catch(() => {
                        toast.error("Nie udało się przedłużyć czasu.");
                    });  
            } else if (!this.checkIsHourGreaterThanNow(this.getHour(this.time[1]))) {
                toast.error("Zwiększ górną granicę zakresu");
            } else if (!this.checkIsHourSmallerThanNow(this.getHour(this.time[0]))) {
                toast.error("Zmniejsz dolną granicę zakresu");
            }
        },
        initRange() {
            let now = new Date();
            let nowThirtyMinutesLater = new Date();
            nowThirtyMinutesLater = new Date(nowThirtyMinutesLater.setMinutes(nowThirtyMinutesLater.getMinutes() + 30));
            let minutes = now.getMinutes();
            let hour = now.getHours();
            let minutesThirtyMinutesLater = nowThirtyMinutesLater.getMinutes();
            let hourThirtyMinutesLater = nowThirtyMinutesLater.getHours();

            if(this.activeSubProfile.play_from && this.activeSubProfile.play_to) {
                if(this.isOutOfHours) {
                    this.time = [ this.minutesToNumber(`${hour.toString()}:${minutes.toString()}`), this.minutesToNumber(`${hourThirtyMinutesLater.toString()}:${minutesThirtyMinutesLater.toString()}`) ];
                }
            } else {
                if(this.isTimeIsUp || this.isTimeIsUpRemind) {
                    this.time = [ this.minutesToNumber(`${hour.toString()}:${minutes.toString()}`), this.minutesToNumber(`${hourThirtyMinutesLater.toString()}:${minutesThirtyMinutesLater.toString()}`) ];
                }

                if(this.isOutOfHours) {
                    this.time = [ this.minutesToNumber(this.activeSubProfile.play_from || this.activeSubProfile.game_restriction.play_from), this.minutesToNumber(this.activeSubProfile.play_to || this.activeSubProfile.game_restriction.play_to) ];
                }
            }
        },
        checkIsHourGreaterThanNow(hour) {
            let h = hour.split(":")[0];
            let m = hour.split(":")[1];
            let now = new Date();
            let nowWithNewHour = new Date();
            nowWithNewHour.setHours(h, m);
            if(nowWithNewHour > now) {
                return true;
            }
            return false;
        },
        checkIsHourSmallerThanNow(hour) {
            let h = hour.split(":")[0];
            let m = hour.split(":")[1];
            let now = new Date();
            let nowWithNewHour = new Date();
            nowWithNewHour.setHours(h, m);
            if(nowWithNewHour < now) {
                return true;
            }
            return false;
        }                  
    },
    mounted() {
        this.initRange();
        this.isTimeExtend = false;

        window.gemius_event(
            '_action_',
            this.gemiusIdentifier,
            'event=modalTime'
        ); 
    }
}
</script>